import React from 'react'

const CustomOrder = () => {
  return (
    <div className="dashboard">
      <div className="dashboard-container">
        <h1>Custom Order</h1>
      </div>
    </div>
  )
}

export default CustomOrder
